import ZkOption from '../select/src/option';

/* istanbul ignore next */
ZkOption.install = function(Vue) {
  Vue.component(ZkOption.name, ZkOption);
};

export default ZkOption;



// WEBPACK FOOTER //
// ./src/packages/option/index.js